import { PeopleIcon } from "../../images/icons/icons";
import Loader from "../ui/Loader";
import { convertThenFormat } from "./Converts";

export function objectToQueryString(obj) {
  return Object.keys(obj)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&");
}

export function objectToQueryString1(obj) {
  return Object.keys(obj)
    .filter(
      (key) => obj[key] !== null && obj[key] !== undefined && obj[key] !== ""
    )
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&");
}

// Convert query string to object (e.g., "&gym_id=123&status=completed" => {gym_id: "123", status: "completed"})
export function queryStringToObject(queryString) {
  if (!queryString || typeof queryString !== "string") {
    return {};
  }

  // Remove leading '&' or '?' if present
  const cleanQuery = queryString.replace(/^[&?]/, "");

  if (!cleanQuery) {
    return {};
  }

  const obj = {};
  const pairs = cleanQuery.split("&");

  pairs.forEach((pair) => {
    if (pair) {
      const [key, value] = pair.split("=");
      if (key) {
        obj[decodeURIComponent(key)] = value ? decodeURIComponent(value) : "";
      }
    }
  });

  return obj;
}

export const extractFileName = (url) => {
  if (!url) {
    return "NA";
  } else if (typeof url !== "string") {
    url = String(url);
  }

  const fileNameWithExtension = url?.substring(url?.lastIndexOf("/") + 1);
  const fileName = fileNameWithExtension?.split("-")?.slice(1)?.join("-");
  return fileName || "NA";
};

export const getFileFromUrl = async (fileUrl) => {
  try {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const fileName = fileUrl.substring(fileUrl.lastIndexOf("/") + 1);
    const file = new File([blob], fileName, { type: blob.type });
    return file;
  } catch (error) {
    console.error("Error fetching file:", error);
    return null;
  }
};

export const cleanBase64Str = (str) =>
  str
    .replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
    .replace(/^\S+,/, "")
    .replace(/"/g, "");

export const base64ToBlob = (base64String) => {
  try {
    const base64 = base64String
      .replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
      .replace(/^\S+,/, "");

    if (!base64) {
      throw new Error("Base64 string is empty or undefined.");
    }

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: "image/jpeg" });
  } catch (error) {
    console.error("Error decoding base64 string:", error);
    return null;
  }
};

export const createObjectURL = (blob) => {
  if (blob) {
    return URL.createObjectURL(blob);
  } else {
    console.error("Failed to create object URL: Blob is null.");
    return "";
  }
};

export const dataURLToBlob = (dataURL) => {
  if (dataURL.startsWith("data:")) {
    const parts = dataURL.split(",");
    if (parts.length === 2) {
      const byteString = atob(parts[1]);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: parts[0] });
      return blob;
    }
  }
  return dataURL;
};

export const convertBlobToFile = (blobUrl) => {
  return fetch(blobUrl)
    .then((res) => res.blob())
    .then((blob) => {
      const file = new File([blob], "image.jpg", { type: blob.type });
      return file;
    });
};

// Function to convert string to object
export const parseQueryStringToObject1 = (queryString) => {
  const pairs = queryString.substring(1).split("&");
  const obj = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    obj[key] = value;
  });
  return obj;
};

export const parseQueryStringToObject2 = (queryString) => {
  if (!queryString || queryString?.trim() === "") {
    return null;
  }

  const pairs = queryString.substring(1).split("&");
  const obj = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    obj[key] = value;
  });
  return obj;
};

export const parseQueryStringToObject = (queryString) => {
  if (typeof queryString !== "string" || queryString.trim() === "") {
    return null;
  }

  const pairs = queryString.substring(1).split("&");
  const obj = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    obj[key] = decodeURIComponent(value); // Decode URI components
  });
  return obj;
};

export function removeQueryParameter(queryString, parameterNames) {
  const params = new URLSearchParams(queryString);
  parameterNames.forEach((param) => {
    params.delete(param);
  });
  return params.toString();
}

export function CONVERT_CM_TO_FT(heightInCM) {
  const totalHeightInCm = heightInCM || 0;
  const heightInFeet = Math.floor(totalHeightInCm / 30.48); // 1 foot = 30.48 cm
  const remainingCm = totalHeightInCm % 30.48;
  const heightInInches = (remainingCm / 2.54).toFixed(2); // 1 inch = 2.54 cm
  return `${heightInFeet}.${heightInInches}`;
}

export const extractFramesFromVideo1 = (videoFile, frameInterval = 30) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const frames = [];

    video.src = URL.createObjectURL(videoFile);
    video.crossOrigin = "anonymous"; // Handle cross-origin issues if needed

    video.onloadedmetadata = () => {
      const { videoWidth, videoHeight, duration } = video;
      canvas.width = videoWidth;
      canvas.height = videoHeight;

      // Calculate the number of frames based on the frameInterval
      const numberOfFrames = Math.ceil(duration / frameInterval);

      // Function to capture a single frame
      const captureFrame = (time) => {
        return new Promise((resolve) => {
          video.currentTime = time;

          const onFrame = () => {
            ctx.drawImage(video, 0, 0, videoWidth, videoHeight);
            frames.push(canvas.toDataURL("image/jpeg"));
            resolve();
          };

          video.requestVideoFrameCallback(() => {
            setTimeout(onFrame, 0); // Small delay to ensure frame is drawn
          });
        });
      };

      // Capture all frames
      const captureFrames = async () => {
        try {
          const promises = [];
          for (let i = 0; i < numberOfFrames; i++) {
            promises.push(captureFrame(i * frameInterval));
          }
          await Promise.all(promises);
          resolve(frames);
        } catch (error) {
          console.error("Error capturing frames: ", error);
          reject(error);
        }
      };

      captureFrames();
    };

    video.onerror = (e) => {
      console.error("Video error: ", e);
      reject(e);
    };
  });
};

export const extractFramesFromVideo = (videoFile, frameInterval = 10) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const frames = [];

    video.src = URL.createObjectURL(videoFile);
    video.crossOrigin = "anonymous"; // Handle cross-origin issues if needed

    video.onloadedmetadata = () => {
      const { videoWidth, videoHeight, duration } = video;
      canvas.width = videoWidth;
      canvas.height = videoHeight;

      // Calculate the number of frames based on the frameInterval
      const numberOfFrames = Math.ceil(duration / frameInterval);

      // Function to capture a single frame
      const captureFrame = (time) => {
        return new Promise((resolve) => {
          video.currentTime = time;
          // console.log(`Setting currentTime to: ${time}`);

          const onTimeUpdate = () => {
            ctx.drawImage(video, 0, 0, videoWidth, videoHeight);
            frames.push(canvas.toDataURL("image/jpeg"));
            console.log(`Captured frame at time: ${time}`);
            video.removeEventListener("timeupdate", onTimeUpdate);
            resolve();
          };

          video.addEventListener("timeupdate", onTimeUpdate);
        });
      };

      // Capture all frames
      const captureFrames = async () => {
        try {
          for (let i = 0; i < numberOfFrames; i++) {
            await captureFrame(i * frameInterval);
          }
          resolve(frames);
        } catch (error) {
          console.error("Error capturing frames: ", error);
          reject(error);
        }
      };

      captureFrames();
    };

    video.onerror = (e) => {
      console.error("Video error: ", e);
      reject(e);
    };
  });
};

export const saveFrameAsFile = (frame) => {
  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const blob = dataURLtoBlob(frame);
  const file = new File([blob], "thumbnail.jpg", { type: "image/jpeg" });

  return file;
};

export const getCardLabel = (key, isDateSelected, from) => {
  switch (key) {
    case "total":
      return from === "odm"
        ? "Total Subscriptions"
        : from === "referral"
          ? "total Referrals"
          : "All PT Subscriptions";
    case "active":
      return "Active PT";
    case "expiring":
      return isDateSelected ? "Expiring PT" : "Expiring PT This Week";
    case "expired":
      return "Expired PT";
    case "ongoing_session":
      return "Ongoing PT Session Today";
    case "upcoming_session":
      return "Upcoming PT Session Today (All Active PT Members)";
    case "completed_session_today":
      return "Completed PT Session Today";
    case "ongoing_session_expired":
      return "Ongoing PT Session Expired";
    case "total_trial_subscription":
      return `3 Day PT Trial`;
    case "total_pt_trainer":
      return "All PT Trainers";
    case "pt_trainer_with_pt":
      return "Trainers with PT Session";
    case "pt_trainer_without_pt":
      return "Trainers With No PT Session";
    case "total_sales":
      return "Total PT Revenue";
    case "full_payment_received":
      return "Full PT Revenue";
    case "partial_payment_received":
      return `Partial PT Revenue completed`;
    case "partial_payment_pending":
      return `Partial Amount Pending`;
    case "carry_over_partial_received":
      return `Past Partial PT Revenue Completed`;
    case "carry_over_partial_pending":
      return `Past Partial PT Amount Pending`;
    case "total_pending":
      return from === "odm"
        ? `One Day Membership Pending`
        : from === "referral"
          ? "not converted"
          : "Total Pending";
    case "total_completed":
      return from === "odm"
        ? `One Day Membership Completed`
        : "Total Completed";
    case "total_converted":
      return from === "referral" ? "converted" : key.replace(/_/g, " ");
    case "total_added_to_lead":
      return from === "referral" || from === "odm"
        ? "added to LMS"
        : key.replace(/_/g, " ");
    case "total_not_added_to_lead":
      return from === "referral" || from === "odm"
        ? "not added to LMS"
        : key.replace(/_/g, " ");
    case "added_to_lead":
      return "added to LMS";
    case "not_added_to_lead":
      return "not added to LMS";
    case "total_male":
      return "Male";
    case "total_female":
      return "Female";
    case "total_unspecified_gender":
      return "unspecified gender";
    case "assigned_converted_lead_value":
      return "Expected Lead Value";
    case "assigned_converted_converted_value":
      return "Converted Lead Value";
    default:
      return key.replace(/_/g, " ");
  }
};

export const getModCardLabel = (key) => {
  switch (key) {
    case "partial_payment_received":
      return `Partial PT Revenue completed (Payment Credited Within The Selected Date Range)`;
    case "partial_payment_pending":
      return `Partial Amount Pending (Payment Due Within The Selected Date Range)`;
    case "total_sales_today":
      return `Today's PT Sale Details`;
    default:
      return key.replace(/_/g, " ");
  }
};

export const getCardValue = (key = "", value = 0, amount = 0) => {
  switch (key) {
    case "total_sales":
      return `₹${convertThenFormat(value || 0)}`;
    case "full_payment_received":
      return `₹${convertThenFormat(value || 0)}`;
    case "partial_payment_received":
      return `₹${convertThenFormat(value || 0)}`;
    case "partial_payment_pending":
      return `₹${convertThenFormat(value || 0)}`;
    case "carry_over_partial_received":
      return `₹${convertThenFormat(value || 0)}`;
    case "carry_over_partial_pending":
      return `₹${convertThenFormat(value || 0)}`;
    case "total_converted":
      return `₹${convertThenFormat(amount || 0)} (${value || 0})`;
    case "assigned_converted_lead_value":
      return `₹${convertThenFormat(value || 0)} (${amount || 0})`;
    case "assigned_converted_converted_value":
      return `₹${convertThenFormat(value || 0)}`;
    default:
      return convertThenFormat(value || 0);
  }
};

export const getCardIcon = (key, loading, from) => {
  switch (key) {
    case "total":
      return loading ? (
        <Loader />
      ) : from === "odm" ? null : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-people-fill"
          viewBox="0 0 16 16"
        >
          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
        </svg>
      );
    case "active":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-check"
          viewBox="0 0 16 16"
        >
          <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
          <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
        </svg>
      );
    case "expiring":
    case "total_checkout":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-exclamation"
          viewBox="0 0 16 16"
        >
          <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
          <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5m0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
        </svg>
      );
    case "expired":
    case "total_late_checkin":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-fill-x"
          viewBox="0 0 16 16"
        >
          <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4" />
          <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708" />
        </svg>
      );
    case "ongoing_session":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            d="M15.1353 21.2539C11.3403 21.2539 8.25781 24.3289 8.25781 28.1314C8.25781 31.9339 11.3328 35.0089 15.1353 35.0089C18.9303 35.0089 22.0128 31.9339 22.0128 28.1314C22.0128 24.3289 18.9303 21.2539 15.1353 21.2539ZM15.1353 32.8864C12.5028 32.8864 10.3728 30.7564 10.3728 28.1239C10.3728 25.4914 12.5028 23.3614 15.1353 23.3614C17.7678 23.3614 19.8978 25.4914 19.8978 28.1239C19.8978 30.7564 17.7603 32.8864 15.1353 32.8864Z"
            fill="#B20A0A"
          />
          <path
            d="M40.1969 10.9961L37.6319 5.55108C37.2044 4.79358 36.4769 4.92858 36.2219 5.04858L21.3194 12.0686C20.8844 12.2786 20.6369 12.7511 20.7344 13.2311L20.9519 14.3261L17.0669 16.1561L16.3619 15.2936C16.0544 14.9186 15.5294 14.7986 15.0944 15.0086L10.0769 17.3711C4.14438 20.1686 1.59438 27.2711 4.39187 33.1961C4.74437 33.9536 5.18687 34.6511 5.68187 35.2961C4.08437 35.8061 2.92188 37.3061 2.92188 39.0761C2.92188 41.2661 4.69937 43.0436 6.88937 43.0436C9.04187 43.0436 10.7894 41.3336 10.8494 39.1961C12.2069 39.7286 13.6619 40.0136 15.1544 40.0136C15.1544 40.0136 17.9744 39.9536 20.2169 38.8736C26.1269 36.0311 28.6994 28.9736 25.9019 23.0486C25.6919 22.6061 25.4594 22.1786 25.1894 21.7586L39.8219 12.3236C40.2569 12.0461 40.4219 11.4761 40.1969 10.9961ZM6.87437 40.9361C5.85437 40.9361 5.02937 40.1036 5.02937 39.0836C5.02937 38.0636 5.86187 37.2311 6.88187 37.2311C7.90187 37.2311 8.73437 38.0636 8.73437 39.0836C8.73437 40.1036 7.90187 40.9361 6.87437 40.9361ZM23.1119 20.5886C22.1444 21.2186 22.6694 21.8936 22.8494 22.1261C23.2919 22.6961 23.6744 23.3186 23.9819 23.9636C26.2769 28.8386 24.1769 34.6661 19.3094 36.9761C17.4419 37.8611 15.1469 37.9136 15.1469 37.9136C11.3744 37.9136 7.90187 35.7086 6.29687 32.3036C4.00187 27.4286 6.09437 21.5936 10.9694 19.2911L15.2444 17.2736L15.9494 18.1361C16.2569 18.5111 16.7819 18.6311 17.2169 18.4211L22.5944 15.8861C23.0294 15.6761 23.2769 15.2036 23.1794 14.7236L22.9619 13.6286L36.1619 7.40358L37.8794 11.0561L23.1119 20.5886Z"
            fill="#B20A0A"
          />
          <path
            d="M35.2833 26.9496L36.4729 31.3892L37.6917 29.2783C40.0243 30.625 40.8228 33.605 39.476 35.9376C39.0637 36.6518 38.4983 37.2167 37.8475 37.629L38.2817 39.2495C39.3307 38.6918 40.2455 37.8549 40.8833 36.7501C42.679 33.64 41.6143 29.6666 38.5042 27.871L39.7229 25.76L35.2833 26.9496ZM32.8167 37.722C30.4841 36.3753 29.6856 33.3952 31.0323 31.0626C31.4446 30.3484 32.01 29.7836 32.6609 29.3712L32.2267 27.7508C31.1776 28.3085 30.2628 29.1454 29.625 30.2501C27.8294 33.3602 28.8941 37.3337 32.0042 39.1293L30.7854 41.2402L35.225 40.0507L34.0354 35.6111L32.8167 37.722Z"
            fill="#B20A0A"
          />
        </svg>
      );
    case "upcoming_session":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            d="M15.1353 21.2539C11.3403 21.2539 8.25781 24.3289 8.25781 28.1314C8.25781 31.9339 11.3328 35.0089 15.1353 35.0089C18.9303 35.0089 22.0128 31.9339 22.0128 28.1314C22.0128 24.3289 18.9303 21.2539 15.1353 21.2539ZM15.1353 32.8864C12.5028 32.8864 10.3728 30.7564 10.3728 28.1239C10.3728 25.4914 12.5028 23.3614 15.1353 23.3614C17.7678 23.3614 19.8978 25.4914 19.8978 28.1239C19.8978 30.7564 17.7603 32.8864 15.1353 32.8864Z"
            fill="#B20A0A"
          />
          <path
            d="M40.1969 10.9961L37.6319 5.55108C37.2044 4.79358 36.4769 4.92858 36.2219 5.04858L21.3194 12.0686C20.8844 12.2786 20.6369 12.7511 20.7344 13.2311L20.9519 14.3261L17.0669 16.1561L16.3619 15.2936C16.0544 14.9186 15.5294 14.7986 15.0944 15.0086L10.0769 17.3711C4.14438 20.1686 1.59438 27.2711 4.39187 33.1961C4.74437 33.9536 5.18687 34.6511 5.68187 35.2961C4.08437 35.8061 2.92188 37.3061 2.92188 39.0761C2.92188 41.2661 4.69937 43.0436 6.88937 43.0436C9.04187 43.0436 10.7894 41.3336 10.8494 39.1961C12.2069 39.7286 13.6619 40.0136 15.1544 40.0136C15.1544 40.0136 17.9744 39.9536 20.2169 38.8736C26.1269 36.0311 28.6994 28.9736 25.9019 23.0486C25.6919 22.6061 25.4594 22.1786 25.1894 21.7586L39.8219 12.3236C40.2569 12.0461 40.4219 11.4761 40.1969 10.9961ZM6.87437 40.9361C5.85437 40.9361 5.02937 40.1036 5.02937 39.0836C5.02937 38.0636 5.86187 37.2311 6.88187 37.2311C7.90187 37.2311 8.73437 38.0636 8.73437 39.0836C8.73437 40.1036 7.90187 40.9361 6.87437 40.9361ZM23.1119 20.5886C22.1444 21.2186 22.6694 21.8936 22.8494 22.1261C23.2919 22.6961 23.6744 23.3186 23.9819 23.9636C26.2769 28.8386 24.1769 34.6661 19.3094 36.9761C17.4419 37.8611 15.1469 37.9136 15.1469 37.9136C11.3744 37.9136 7.90187 35.7086 6.29687 32.3036C4.00187 27.4286 6.09437 21.5936 10.9694 19.2911L15.2444 17.2736L15.9494 18.1361C16.2569 18.5111 16.7819 18.6311 17.2169 18.4211L22.5944 15.8861C23.0294 15.6761 23.2769 15.2036 23.1794 14.7236L22.9619 13.6286L36.1619 7.40358L37.8794 11.0561L23.1119 20.5886Z"
            fill="#B20A0A"
          />
          <path
            d="M42.05 29.65H40.35V26.25C40.35 26.0246 40.2604 25.8084 40.101 25.649C39.9416 25.4896 39.7254 25.4 39.5 25.4C39.2746 25.4 39.0584 25.4896 38.899 25.649C38.7396 25.8084 38.65 26.0246 38.65 26.25V30.5C38.65 30.7254 38.7396 30.9416 38.899 31.101C39.0584 31.2604 39.2746 31.35 39.5 31.35H42.05C42.2754 31.35 42.4916 31.2604 42.651 31.101C42.8104 30.9416 42.9 30.7254 42.9 30.5C42.9 30.2746 42.8104 30.0584 42.651 29.899C42.4916 29.7396 42.2754 29.65 42.05 29.65ZM39.5 22C37.8189 22 36.1755 22.4985 34.7777 23.4325C33.3798 24.3665 32.2904 25.694 31.647 27.2472C31.0037 28.8004 30.8354 30.5094 31.1633 32.1583C31.4913 33.8071 32.3008 35.3217 33.4896 36.5104C34.6783 37.6992 36.1929 38.5087 37.8417 38.8367C39.4906 39.1646 41.1996 38.9963 42.7528 38.353C44.306 37.7096 45.6335 36.6202 46.5675 35.2223C47.5015 33.8245 48 32.1811 48 30.5C47.9975 28.2464 47.1012 26.0859 45.5076 24.4924C43.9141 22.8988 41.7536 22.0025 39.5 22ZM39.5 37.3C38.1551 37.3 36.8404 36.9012 35.7221 36.154C34.6039 35.4068 33.7323 34.3448 33.2176 33.1022C32.7029 31.8597 32.5683 30.4925 32.8307 29.1734C33.093 27.8543 33.7407 26.6427 34.6917 25.6917C35.6427 24.7407 36.8543 24.093 38.1734 23.8307C39.4925 23.5683 40.8597 23.7029 42.1022 24.2176C43.3448 24.7323 44.4068 25.6039 45.154 26.7221C45.9012 27.8404 46.3 29.1551 46.3 30.5C46.2979 32.3028 45.5808 34.0312 44.306 35.306C43.0312 36.5808 41.3028 37.2979 39.5 37.3Z"
            fill="#B20A0A"
          />
        </svg>
      );
    case "completed_session_today":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            d="M15.1353 21.2539C11.3403 21.2539 8.25781 24.3289 8.25781 28.1314C8.25781 31.9339 11.3328 35.0089 15.1353 35.0089C18.9303 35.0089 22.0128 31.9339 22.0128 28.1314C22.0128 24.3289 18.9303 21.2539 15.1353 21.2539ZM15.1353 32.8864C12.5028 32.8864 10.3728 30.7564 10.3728 28.1239C10.3728 25.4914 12.5028 23.3614 15.1353 23.3614C17.7678 23.3614 19.8978 25.4914 19.8978 28.1239C19.8978 30.7564 17.7603 32.8864 15.1353 32.8864Z"
            fill="#B20A0A"
          />
          <path
            d="M40.1969 10.9961L37.6319 5.55108C37.2044 4.79358 36.4769 4.92858 36.2219 5.04858L21.3194 12.0686C20.8844 12.2786 20.6369 12.7511 20.7344 13.2311L20.9519 14.3261L17.0669 16.1561L16.3619 15.2936C16.0544 14.9186 15.5294 14.7986 15.0944 15.0086L10.0769 17.3711C4.14438 20.1686 1.59438 27.2711 4.39187 33.1961C4.74437 33.9536 5.18687 34.6511 5.68187 35.2961C4.08437 35.8061 2.92188 37.3061 2.92188 39.0761C2.92188 41.2661 4.69937 43.0436 6.88937 43.0436C9.04187 43.0436 10.7894 41.3336 10.8494 39.1961C12.2069 39.7286 13.6619 40.0136 15.1544 40.0136C15.1544 40.0136 17.9744 39.9536 20.2169 38.8736C26.1269 36.0311 28.6994 28.9736 25.9019 23.0486C25.6919 22.6061 25.4594 22.1786 25.1894 21.7586L39.8219 12.3236C40.2569 12.0461 40.4219 11.4761 40.1969 10.9961ZM6.87437 40.9361C5.85437 40.9361 5.02937 40.1036 5.02937 39.0836C5.02937 38.0636 5.86187 37.2311 6.88187 37.2311C7.90187 37.2311 8.73437 38.0636 8.73437 39.0836C8.73437 40.1036 7.90187 40.9361 6.87437 40.9361ZM23.1119 20.5886C22.1444 21.2186 22.6694 21.8936 22.8494 22.1261C23.2919 22.6961 23.6744 23.3186 23.9819 23.9636C26.2769 28.8386 24.1769 34.6661 19.3094 36.9761C17.4419 37.8611 15.1469 37.9136 15.1469 37.9136C11.3744 37.9136 7.90187 35.7086 6.29687 32.3036C4.00187 27.4286 6.09437 21.5936 10.9694 19.2911L15.2444 17.2736L15.9494 18.1361C16.2569 18.5111 16.7819 18.6311 17.2169 18.4211L22.5944 15.8861C23.0294 15.6761 23.2769 15.2036 23.1794 14.7236L22.9619 13.6286L36.1619 7.40358L37.8794 11.0561L23.1119 20.5886Z"
            fill="#B20A0A"
          />
          <path
            d="M37.6062 38.4C41.5827 38.4 44.8062 35.1764 44.8062 31.2C44.8062 27.2235 41.5827 24 37.6062 24C33.6298 24 30.4062 27.2235 30.4062 31.2C30.4062 35.1764 33.6298 38.4 37.6062 38.4Z"
            stroke="#B20A0A"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M34.4062 31.2008L36.0063 32.8008L40.8063 28.8008"
            stroke="#B20A0A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "ongoing_session_expired":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            d="M15.1353 21.2539C11.3403 21.2539 8.25781 24.3289 8.25781 28.1314C8.25781 31.9339 11.3328 35.0089 15.1353 35.0089C18.9303 35.0089 22.0128 31.9339 22.0128 28.1314C22.0128 24.3289 18.9303 21.2539 15.1353 21.2539ZM15.1353 32.8864C12.5028 32.8864 10.3728 30.7564 10.3728 28.1239C10.3728 25.4914 12.5028 23.3614 15.1353 23.3614C17.7678 23.3614 19.8978 25.4914 19.8978 28.1239C19.8978 30.7564 17.7603 32.8864 15.1353 32.8864Z"
            fill="#B20A0A"
          />
          <path
            d="M40.1969 10.9961L37.6319 5.55108C37.2044 4.79358 36.4769 4.92858 36.2219 5.04858L21.3194 12.0686C20.8844 12.2786 20.6369 12.7511 20.7344 13.2311L20.9519 14.3261L17.0669 16.1561L16.3619 15.2936C16.0544 14.9186 15.5294 14.7986 15.0944 15.0086L10.0769 17.3711C4.14438 20.1686 1.59438 27.2711 4.39187 33.1961C4.74437 33.9536 5.18687 34.6511 5.68187 35.2961C4.08437 35.8061 2.92188 37.3061 2.92188 39.0761C2.92188 41.2661 4.69937 43.0436 6.88937 43.0436C9.04187 43.0436 10.7894 41.3336 10.8494 39.1961C12.2069 39.7286 13.6619 40.0136 15.1544 40.0136C15.1544 40.0136 17.9744 39.9536 20.2169 38.8736C26.1269 36.0311 28.6994 28.9736 25.9019 23.0486C25.6919 22.6061 25.4594 22.1786 25.1894 21.7586L39.8219 12.3236C40.2569 12.0461 40.4219 11.4761 40.1969 10.9961ZM6.87437 40.9361C5.85437 40.9361 5.02937 40.1036 5.02937 39.0836C5.02937 38.0636 5.86187 37.2311 6.88187 37.2311C7.90187 37.2311 8.73437 38.0636 8.73437 39.0836C8.73437 40.1036 7.90187 40.9361 6.87437 40.9361ZM23.1119 20.5886C22.1444 21.2186 22.6694 21.8936 22.8494 22.1261C23.2919 22.6961 23.6744 23.3186 23.9819 23.9636C26.2769 28.8386 24.1769 34.6661 19.3094 36.9761C17.4419 37.8611 15.1469 37.9136 15.1469 37.9136C11.3744 37.9136 7.90187 35.7086 6.29687 32.3036C4.00187 27.4286 6.09437 21.5936 10.9694 19.2911L15.2444 17.2736L15.9494 18.1361C16.2569 18.5111 16.7819 18.6311 17.2169 18.4211L22.5944 15.8861C23.0294 15.6761 23.2769 15.2036 23.1794 14.7236L22.9619 13.6286L36.1619 7.40358L37.8794 11.0561L23.1119 20.5886Z"
            fill="#B20A0A"
          />
          <path
            d="M37.6062 38.4C41.5827 38.4 44.8062 35.1764 44.8062 31.2C44.8062 27.2235 41.5827 24 37.6062 24C33.6298 24 30.4062 27.2235 30.4062 31.2C30.4062 35.1764 33.6298 38.4 37.6062 38.4Z"
            stroke="#B20A0A"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M39.5679 33.1636L35.6406 29.2363M35.6406 33.1636L39.5679 29.2363"
            stroke="#B20A0A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "total_pt_trainer":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="61"
          height="48"
          viewBox="0 0 61 48"
          fill="none"
        >
          <path
            d="M4.71875 24.0078C4.71875 19.5939 6.47216 15.3608 9.59325 12.2397C12.7143 9.11864 16.9474 7.36523 21.3613 7.36523C25.7752 7.36523 30.0083 9.11864 33.1294 12.2397C36.2505 15.3608 38.0039 19.5939 38.0039 24.0078V33.716C38.0036 34.2288 37.8612 34.7314 37.5924 35.1681C37.3237 35.6049 36.9391 35.9585 36.4815 36.1899C36.0238 36.4212 35.511 36.5211 35 36.4786C34.489 36.4361 33.9998 36.2527 33.5867 35.9489C30.8147 33.9344 26.7355 32.3291 21.3613 32.3291C15.9872 32.3291 11.908 33.9344 9.13597 35.9489C8.72288 36.2527 8.23366 36.4361 7.72264 36.4786C7.21163 36.5211 6.69882 36.4212 6.24118 36.1899C5.78354 35.9585 5.39899 35.6049 5.13023 35.1681C4.86148 34.7314 4.71904 34.2288 4.71875 33.716V24.0078Z"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.71875 28.1706C9.52003 24.5696 15.3597 22.623 21.3613 22.623C27.3629 22.623 33.2026 24.5696 38.0039 28.1706"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.4922 23.4773C15.2151 13.5074 21.3573 7.36523 21.3573 7.36523C21.3573 7.36523 27.4994 13.5074 28.2223 23.4773"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "pt_trainer_with_pt":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="61"
          height="48"
          viewBox="0 0 61 48"
          fill="none"
        >
          <path
            d="M4.71875 24.0078C4.71875 19.5939 6.47216 15.3608 9.59325 12.2397C12.7143 9.11864 16.9474 7.36523 21.3613 7.36523C25.7752 7.36523 30.0083 9.11864 33.1294 12.2397C36.2505 15.3608 38.0039 19.5939 38.0039 24.0078V33.716C38.0036 34.2288 37.8612 34.7314 37.5924 35.1681C37.3237 35.6049 36.9391 35.9585 36.4815 36.1899C36.0238 36.4212 35.511 36.5211 35 36.4786C34.489 36.4361 33.9998 36.2527 33.5867 35.9489C30.8147 33.9344 26.7355 32.3291 21.3613 32.3291C15.9872 32.3291 11.908 33.9344 9.13597 35.9489C8.72288 36.2527 8.23366 36.4361 7.72264 36.4786C7.21163 36.5211 6.69882 36.4212 6.24118 36.1899C5.78354 35.9585 5.39899 35.6049 5.13023 35.1681C4.86148 34.7314 4.71904 34.2288 4.71875 33.716V24.0078Z"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.71875 28.1706C9.52003 24.5696 15.3597 22.623 21.3613 22.623C27.3629 22.623 33.2026 24.5696 38.0039 28.1706"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.4922 23.4773C15.2151 13.5074 21.3573 7.36523 21.3573 7.36523C21.3573 7.36523 27.4994 13.5074 28.2223 23.4773"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.0117 35.0234C53.8842 35.0234 57.0234 31.8842 57.0234 28.0117C57.0234 24.1393 53.8842 21 50.0117 21C46.1393 21 43 24.1393 43 28.0117C43 31.8842 46.1393 35.0234 50.0117 35.0234Z"
            stroke="#B20A0A"
            strokeWidth="1.9477"
            strokeLinejoin="round"
          />
          <path
            d="M46.8906 28.0111L48.4488 29.5692L53.1233 25.6738"
            stroke="#B20A0A"
            strokeWidth="1.9477"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "pt_trainer_without_pt":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="61"
          height="48"
          viewBox="0 0 61 48"
          fill="none"
        >
          <path
            d="M4.71875 24.0078C4.71875 19.5939 6.47216 15.3608 9.59325 12.2397C12.7143 9.11864 16.9474 7.36523 21.3613 7.36523C25.7752 7.36523 30.0083 9.11864 33.1294 12.2397C36.2505 15.3608 38.0039 19.5939 38.0039 24.0078V33.716C38.0036 34.2288 37.8612 34.7314 37.5924 35.1681C37.3237 35.6049 36.9391 35.9585 36.4815 36.1899C36.0238 36.4212 35.511 36.5211 35 36.4786C34.489 36.4361 33.9998 36.2527 33.5867 35.9489C30.8147 33.9344 26.7355 32.3291 21.3613 32.3291C15.9872 32.3291 11.908 33.9344 9.13597 35.9489C8.72288 36.2527 8.23366 36.4361 7.72264 36.4786C7.21163 36.5211 6.69882 36.4212 6.24118 36.1899C5.78354 35.9585 5.39899 35.6049 5.13023 35.1681C4.86148 34.7314 4.71904 34.2288 4.71875 33.716V24.0078Z"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.71875 28.1706C9.52003 24.5696 15.3597 22.623 21.3613 22.623C27.3629 22.623 33.2026 24.5696 38.0039 28.1706"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.4922 23.4773C15.2151 13.5074 21.3573 7.36523 21.3573 7.36523C21.3573 7.36523 27.4994 13.5074 28.2223 23.4773"
            stroke="#B20A0A"
            strokeWidth="2.30434"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.0117 35.0234C53.8842 35.0234 57.0234 31.8842 57.0234 28.0117C57.0234 24.1393 53.8842 21 50.0117 21C46.1393 21 43 24.1393 43 28.0117C43 31.8842 46.1393 35.0234 50.0117 35.0234Z"
            stroke="#B20A0A"
            strokeWidth="1.9477"
            strokeLinejoin="round"
          />
          <path
            d="M51.9273 29.9273L48 26M48 29.9273L51.9273 26"
            stroke="#B20A0A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "total_trial_subscription":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-3-circle-fill"
          viewBox="0 0 16 16"
        >
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-8.082.414c.92 0 1.535.54 1.541 1.318.012.791-.615 1.36-1.588 1.354-.861-.006-1.482-.469-1.54-1.066H5.104c.047 1.177 1.05 2.144 2.754 2.144 1.653 0 2.954-.937 2.93-2.396-.023-1.278-1.031-1.846-1.734-1.916v-.07c.597-.1 1.505-.739 1.482-1.876-.03-1.177-1.043-2.074-2.637-2.062-1.675.006-2.59.984-2.625 2.12h1.248c.036-.556.557-1.054 1.348-1.054.785 0 1.348.486 1.348 1.195.006.715-.563 1.237-1.342 1.237h-.838v1.072h.879Z" />
        </svg>
      );
    case "total_pending":
      return loading ? (
        <Loader />
      ) : from === "odm" ? null : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-hourglass-split"
          viewBox="0 0 16 16"
        >
          <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
        </svg>
      );
    case "total_completed":
      return loading ? (
        <Loader />
      ) : from === "odm" ? null : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-hourglass-bottom"
          viewBox="0 0 16 16"
        >
          <path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5m2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702s.18.149.5.149.5-.15.5-.15v-.7c0-.701.478-1.236 1.011-1.492A3.5 3.5 0 0 0 11.5 3V2z" />
        </svg>
      );
    case "total_converted":
      return loading ? (
        <Loader />
      ) : from === "odm" ? null : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-patch-check-fill"
          viewBox="0 0 16 16"
        >
          <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708" />
        </svg>
      );
    case "total_not_converted":
      return loading ? (
        <Loader />
      ) : from === "odm" ? null : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x-octagon-fill"
          viewBox="0 0 16 16"
        >
          <path d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zm-6.106 4.5L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708" />
        </svg>
      );
    case "total_added_to_lead":
      return loading ? (
        <Loader />
      ) : from === "odm" ? null : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-cart-plus-fill"
          viewBox="0 0 16 16"
        >
          <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9 5.5V7h1.5a.5.5 0 0 1 0 1H9v1.5a.5.5 0 0 1-1 0V8H6.5a.5.5 0 0 1 0-1H8V5.5a.5.5 0 0 1 1 0" />
        </svg>
      );
    case "total_not_added_to_lead":
      return loading ? (
        <Loader />
      ) : from === "odm" ? null : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-cart-x-fill"
          viewBox="0 0 16 16"
        >
          <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.354 5.646 8.5 6.793l1.146-1.147a.5.5 0 0 1 .708.708L9.207 7.5l1.147 1.146a.5.5 0 0 1-.708.708L8.5 8.207 7.354 9.354a.5.5 0 1 1-.708-.708L7.793 7.5 6.646 6.354a.5.5 0 1 1 .708-.708" />
        </svg>
      );
    case "total_staff":
      return <PeopleIcon />;
    case "total_receptionist":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-standing-dress"
          viewBox="0 0 16 16"
        >
          <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-.5 12.25V12h1v3.25a.75.75 0 0 0 1.5 0V12h1l-1-5v-.215a.285.285 0 0 1 .56-.078l.793 2.777a.711.711 0 1 0 1.364-.405l-1.065-3.461A3 3 0 0 0 8.784 3.5H7.216a3 3 0 0 0-2.868 2.118L3.283 9.079a.711.711 0 1 0 1.365.405l.793-2.777a.285.285 0 0 1 .56.078V7l-1 5h1v3.25a.75.75 0 0 0 1.5 0Z" />
        </svg>
      );
    case "total_checkin":
    case "total_trainer_checkin":
    case "total_receptionist_checkin":
    case "total_on_time_checkin":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-check-fill"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0"
          />
          <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
        </svg>
      );
    case "total_trainer":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-raised-hand"
          viewBox="0 0 16 16"
        >
          <path d="M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a1 1 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207" />
          <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
        </svg>
      );
    case "total_absent":
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-person-slash"
          viewBox="0 0 16 16"
        >
          <path d="M13.879 10.414a2.501 2.501 0 0 0-3.465 3.465zm.707.707-3.465 3.465a2.501 2.501 0 0 0 3.465-3.465m-4.56-1.096a3.5 3.5 0 1 1 4.949 4.95 3.5 3.5 0 0 1-4.95-4.95ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
        </svg>
      );
    case "_":
      return loading ? <Loader /> : null;
    default:
      return loading ? (
        <Loader />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-people-fill"
          viewBox="0 0 16 16"
        >
          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
        </svg>
      );
  }
};

export const getReplace = (str) => {
  return str?.replace(/[_-]/g, ", ");
};

export const getReplace1 = (str) => {
  return str?.replace(/[_-]/g, " ");
};

export function formatWTFString(input) {
  if (!input) {
    return "NA";
  }

  let formattedString = input.toLowerCase();
  formattedString = formattedString.replace(/wtf/g, "WTF");
  formattedString = formattedString.replace(/_/g, " ");

  return formattedString;
}

export function sumTwoNumbers(num1, num2) {
  const number1 = parseFloat(num1);
  const number2 = parseFloat(num2);

  if (num1 === undefined && num2 === undefined) {
    return 0;
  }

  if (isNaN(number1) || isNaN(number2)) {
    return "Invalid input";
  }

  return number1 + number2;
}

export const extractExpiredDaysAgo = (arr) => {
  let days_ago = [];

  arr?.length > 0 &&
    arr.forEach((item) => {
      const itemValue = item.value;
      days_ago.push(itemValue);
    });

  return {
    days_ago: days_ago.join(", "),
  };
};

export const formatQuillContent = (htmlContent) => {
  if (!htmlContent) return "No Content Available";
  return htmlContent
    .replace(/<pre class="ql-syntax"[^>]*>/g, "<mark>")
    .replace(/<\/pre>/g, "</mark>");
};

export const slugify = (value) => {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9\s-_]/g, "")
    .replace(/\s+/g, "_")
    .trim();
};

export function genericFunction(url) {
  const docts_s3 = {
    s3: "wtfupme-documents-1435.s3.ap-south-1.amazonaws.com",
    cloudfront: "dry2o5w6nqoyb.cloudfront.net",
  };

  const img_s3 = {
    s3: "wtfupme-images-1435.s3.ap-south-1.amazonaws.com",
    cloudfront: "d1e9q0asw0l2kk.cloudfront.net",
  };

  const video_s3 = {
    s3: "wtfupme-videos-1435.s3.ap-south-1.amazonaws.com",
    cloudfront: "d1gzvbhpg92x41.cloudfront.net",
  };
  const video_100ms = {
    s3: "wtfupme-100ms-1435.s3.ap-south-1.amazonaws.com",
    cloudfront: "dfodc18fawhhz.cloudfront.net",
  };

  if (!url) {
    return null;
  }

  if (url.includes(docts_s3.s3)) {
    return url.replace(docts_s3.s3, docts_s3.cloudfront);
  }

  if (url.includes(img_s3.s3)) {
    return url.replace(img_s3.s3, img_s3.cloudfront);
  }

  if (url.includes(video_s3.s3)) {
    return url.replace(video_s3.s3, video_s3.cloudfront);
  }

  if (url.includes(video_100ms.s3)) {
    return url.replace(video_100ms.s3, video_100ms.cloudfront);
  }

  // Azure Blob Storage URLs and any other URLs — return as-is
  return url;
}

export const stripHtml = (html) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

export const isManagerRole = (userInfoData) =>
  [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
    // "gym",
  ].includes(userInfoData?.account_type);

export const checkIsManagerRole = (userInfoData) =>
  [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
    "inside_sale",
    // "gym",
  ].includes(userInfoData?.account_type);

// Single-gym users: each has exactly ONE assigned gym (no dropdown needed).
// Trainer:      users.gym_id
// Receptionist: receptionist_master.gym_id
// Gym owner:    users.uid IS the gym_id
export const isSingleGymUser = (userInfoData) =>
  ["trainer", "receptionist", "gym"].includes(userInfoData?.account_type);

// Multi-gym managers: 4 manager roles, may have many assigned gyms.
// Dropdown should be shown but only with their authorized set.
export const isMultiGymManager = (userInfoData) =>
  ["sales_manager", "fitness_manager", "club_manager", "cluster_manager"]
    .includes(userInfoData?.account_type);

// Any non-admin gym-restricted user — used to gate "all gyms" UI.
export const isGymRestricted = (userInfoData) =>
  isSingleGymUser(userInfoData) || isMultiGymManager(userInfoData);